import { Container, Sprite } from 'pixi.js';

export class TargetDirector extends  Container{
    constructor(actor, tilemap){
        super();
        this.offset = tilemap.tileOffset;
        this.actor = actor;
        this.bigChevron = new Sprite.from("arrow");
        this.bigChevron.x = 130;
        this.bigChevron.anchor.set(0.5);
        this.bigChevron.scale.set(0.3);
        this.littleChevron = new Sprite.from("arrow");
        this.littleChevron.x = 180;
        this.littleChevron.scale.set(0.2);
        this.littleChevron.anchor.set(0.5);

        this.addChild(this.bigChevron);
        this.addChild(this.littleChevron);
    }

    setTarget(position){
        this.target = position.entity;
        console.log(this.target.x, this.target.y);
    }

    pointAtTarget(){
        let rad = Math.atan2(this.target.y - this.actor.y, this.target.x - this.actor.x);
        let dist = Math.hypot(this.target.y - this.actor.y, this.target.x - this.actor.x);
        this.rotation = rad;

        if (dist < 1500){
            this.littleChevron.visible = false;
        }
        else{
            this.littleChevron.visible = true;
        }
    }

    update(){
        if (this.target){
            if (!this.visible){
                this.visible = true;
            }
            if (this.actor.transform){
                this.position.set(this.actor.position.x + this.offset.x, this.actor.position.y - 75 + this.offset.y);
                this.pointAtTarget();
            }
        }
        else if (this.visible){
            this.visible = false;
        }
    }
}
